var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'guide-is-active': _vm.isGuideActive,
    'landing-page': _vm.isLandingPage,
  },attrs:{"id":"app"}},[_c('el-header',[_c('custom-menu')],1),_c('el-main',{class:{
      'is-mobile': _vm.isMobile,
    }},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('el-footer',{attrs:{"height":"60"}},[_c('span',[_vm._v("Обазривко")]),_c('span',{staticClass:"el-footer-usage"},[_vm._v("Сва права задржана")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }